import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Grid, InputAdornment } from "@mui/material";

import { DateInput, TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";
import { StepComponentProps } from "@/components/organisms";
import { StyledHeaderTitleBase } from "@/styles/components";

import { CompanyFormType } from "../../formType";

const FinancialStep: FC<StepComponentProps> = () => {
    const { t } = useTranslation();

    const { control } = useFormContext<CompanyFormType>();

    return (
        <>
            <StyledHeaderTitleBase>{t("Common.FinancialTax")}</StyledHeaderTitleBase>
            <Grid container marginTop={1} marginBottom={2}>
                <Grid item sm={8} xs={12}>
                    <RefSelectInput name="fiscalFinancial.fiscalStatus" table="taxStatusMoral" control={control} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <DateInput
                        name="fiscalFinancial.endOfFiscalYear"
                        control={control}
                        openTo="month"
                        views={["month", "day"]}
                        format="dd/MM"
                        placeholder="dd/MM"
                        label={t("Common.EndOfFiscalYear")}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <TextInput name="fiscalFinancial.vatNumber" control={control} label={t("Common.VatNumber")} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <TextInput
                        name="fiscalFinancial.vatExemption"
                        type="number"
                        control={control}
                        label={t("Common.VatExemption")}
                        InputProps={{
                            inputProps: { min: 0, max: 100, step: "any" },
                            endAdornment: <InputAdornment position="end">&#37;</InputAdornment>,
                        }}
                    />
                </Grid>
                <Grid item sm={8} xs={12}>
                    <TextInput
                        name="fiscalFinancial.bankAccountNumber"
                        control={control}
                        label={t("Common.AccountNumber")}
                    />
                </Grid>
                <Grid item sm={8} xs={12}>
                    <TextInput
                        name="fiscalFinancial.billingEmailAddress"
                        control={control}
                        label={t("Common.BillingEmailAddress")}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default FinancialStep;
